module.exports = __webpack_public_path__ + "static/media/YF47_2.cd1b3a60.jpg";